import { createServiceResolver } from '~api-resources-module/service-resolver'

export default function ({ $axios, $auth }, inject) {
  const resolver = createServiceResolver({ $axios, $auth })
  inject('resolveService', resolver)
}
